import { Link } from "react-router-dom";
import { HiOutlineLockClosed } from "react-icons/hi2";

/** Compact floating card for ticker search limit (not the full-width banner). */
const TickerLimitFloat = ({ message, theme, className = "" }) => {
  if (!message) return null;
  const isDark = theme === "dark";

  return (
    <div
      role="alert"
      className={`pointer-events-auto z-[100] w-full max-w-[min(100%,22rem)] rounded-xl border-2 px-3.5 py-3 shadow-2xl ring-4 ring-amber-500/10 animate-in fade-in zoom-in-95 duration-200 ${className} ${
        isDark
          ? "border-amber-500/50 bg-slate-900/95 text-amber-50 backdrop-blur-md"
          : "border-amber-400 bg-white text-amber-950"
      }`}
    >
      <p className="text-xs font-semibold leading-snug sm:text-sm">{message.headline}</p>
      {message.detail ? (
        <p
          className={`mt-1.5 text-[11px] leading-relaxed sm:text-xs ${
            isDark ? "text-amber-200/85" : "text-amber-900/75"
          }`}
        >
          {message.detail}
        </p>
      ) : null}
      <Link
        to="/payment"
        onMouseDown={(e) => e.preventDefault()}
        className={`mt-2.5 inline-flex items-center gap-1.5 text-xs font-bold underline underline-offset-2 ${
          isDark ? "text-indigo-300 hover:text-indigo-200" : "text-indigo-700 hover:text-indigo-900"
        }`}
      >
        <HiOutlineLockClosed size={14} />
        Subscribe
      </Link>
    </div>
  );
};

export default TickerLimitFloat;
